<template>
  <div id="app">
    <router-view v-if="!currentUser || $route.params.token"/>
    <template v-else-if="currentUser">
      <Navbar></Navbar>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Navbar from '@/components/Navbar'
import JwtDecode from 'jwt-decode'
import Vue from 'vue'
import AirbrakeClient from 'airbrake-js'

export default {
  name: 'App',
  computed: {
    ...mapGetters({ currentUser: 'currentUser' })
  },

  created () {
    if (!this.currentUser) {
      this.$store.commit('redirectToPath', window.location.pathname)
    }
    if (process.env.NODE_ENV === 'production') {
      this.setupAirbrake()
    }
  },

  mounted () {
    if (localStorage.token) {
      let today = new Date()
      today.setHours(today.getHours() - 1)
      let expireAt = new Date(JwtDecode(localStorage.token).exp * 1000)
      if (expireAt < today) {
        this.$http.put('/refresh_token')
          .then(response => this.loginSuccessful(response))
          .catch((e) => this.loginFailed(e))
      } else {
        this.$store.dispatch('loadUsers')
        this.$store.dispatch('loadUser')
        this.$store.dispatch('loadClients')
      }
    } else if (this.$route.params.id && this.$route.params.token) {
      this.$router.push({
        name: 'ExternalMessage',
        params: {
          id: this.$route.params.id,
          token: this.$route.params.token
        }
      })
    } else {
      this.$router.push('/')
    }
  },

  methods: {

    setupAirbrake () {
      var airbrake = new AirbrakeClient({
        projectId: 225366,
        projectKey: 'e5c6407d3b2b4543fef27ca7a70a0d06'
      })
      Vue.config.errorHandler = function (err, vm, info) {
        airbrake.notify({
          error: err,
          params: {info: info}
        })
        airbrake.addFilter(function (notice) {
          if (notice.errors[0].message === 'Network Error') {
            return null
          }
          return notice
        })
      }
    },

    loginSuccessful (response) {
      var token = response.data.jwt
      if (!token) {
        this.loginFailed()
        return
      }
      localStorage.token = token
      this.$store.dispatch('loadUser')
      this.$store.dispatch('loadUsers')
    },

    loginFailed (e) {
      this.error = 'Login failed'
      delete localStorage.token
      this.$store.commit('logout')
      this.$router.push('/')
    }
  },

  components: {
    Navbar
  }
}
</script>

<style>
#app {
  font-family: 'Roboto', Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
a, a:link, a:visited {
  text-decoration: none !important;
}
body {
  background: #FFF;
}
p {
  font-family: 'Roboto', Helvetica, sans-serif !important;
}
table.MsoNormalTable {
  table-layout: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue